'use client'

import React, { useEffect, useRef, useState } from 'react'
import { Col, Row, Divider, Affix, Image, Tooltip, Modal } from 'antd';

import colors from '../../libs/colorFactory';
import formatMsg from '../../util/formatMsg';


import { LeftOutlined, RightOutlined } from '@ant-design/icons';

import Helper from '../../util/helper';
import "./style.css";
import LinkWrapper from '../linkWrapper/page';
import PrefixIconButton from '../buttons/prefixIconButton';
import TncModal from './TncModal';
import { useRouter } from 'next/navigation'
import { Box, ModalWrapper } from '../wrapperComponents/page';
import { bookingActivityActions, BookingConfirmationPopup, getItem, NewBookingStatuses, packageActions, SpinWrapper } from '../..';
import RescheduleBookingModal from '../Booking/RescheduleBookingModal';
import BookSlotsModal from '../Booking/BookSlotsModal';
import CustomPopoverOptions from '../customPopoverOptions/page';
import { useDispatch } from 'react-redux';
import { timeutil } from "sharedresources";

const { changeBookingStatus, resetOperationType } = packageActions;
import batchStyles from './style.module.css'
import GalleryWithCoverPhotos from './GalleryWithCoverPhotos';


export enum FillEntityType {
    TIME = 'TIME',
    CENTER = 'CENTER',
    PRICING = 'PRICING'
}


const PackageBookingOrMembershipDetailView = (props) => {
    const router = useRouter();
    const dispatch = useDispatch();
    const { firebase, entityType, payload, batchDetails } = props;
    const { accountPackageReducer, packageReducer, bookingActivity } = Helper.getSelectorState(["accountPackageReducer", "packageReducer", "bookingActivity"]);
    const { bookingDetails } = accountPackageReducer;

    const [header, setHeader] = useState(false)
    const [rescheduleModal, setRescheduleModal] = useState(false);
    const [termsVisible, setTermsVisible] = useState(false);
    const [showBookingConfirmation, setShowBookingConfirmation] = useState(false);
    const [isPopupOpen, setIsPopupOpen] = useState<any>();
    const [openRescheduleModal, setOpenRescheduleModal] = useState(false);
    const [afterCancel, setAfterCancel] = useState(false);
    const [beforeCancel, setBeforeCancel] = useState(false);

    const [activeModal, setActiveModal] = useState(null);
    const [activeBatchIndex, setActiveBatchIndex] = useState(0);

    const cardsContainerRef = useRef(null);

    const [showLeftArrow, setShowLeftArrow] = useState(false);
    const [showRightArrow, setShowRightArrow] = useState(true);


    // Batch details space fill rendering 

    const batchElementsVisibilityMapRef = useRef<Record<
        string, // batch.id
        {
            visibleTimeCount: number,
            visibleCenterCount: number,
            visiblePricingCount: number
        }
    >>({});

    const [rerenderToggle, setRerenderToggle] = useState(false);


    useEffect(() => {

        if (!cardsContainerRef.current) return;

        const newVisibilityMap: typeof batchElementsVisibilityMapRef.current = {};

        for (const batch of batchDetails) {

            const batchId = batch.id;

            let timeFit = 0;
            let centerFit = 0;
            let pricingFit = 0;

            const timeEls = (
                isSameTimingsBatch(batch)
                    ? batch?.uniqueTimeSlotsObjList
                    : isDifferentTimingsBatch(batch)
                        ? batch?.dayDateTimeSlotsMap
                        : null
            ) || [];
            const centerEls = batch.centersList || [];
            const pricingEls = batch.pricingPackData || [];

            const getEntityElesArrAndFitValue = (fillEntityType: FillEntityType) => {
                switch (fillEntityType) {
                    case FillEntityType.TIME:
                        return { entityArr: timeEls, entityFitNum: timeFit };
                    case FillEntityType.CENTER:
                        return { entityArr: centerEls, entityFitNum: centerFit };
                    case FillEntityType.PRICING:
                        return { entityArr: pricingEls, entityFitNum: pricingFit };
                }
            }

            let toBeFilledSpaces = 9; // number of items 
            const minCount = 3;

            // Reserve space for at least minCount elements from each (if available) 
            timeFit = Math.min(timeEls.length, minCount);
            centerFit = Math.min(centerEls.length, minCount);
            pricingFit = Math.min(pricingEls.length, minCount);

            const filledSpaces = timeFit + centerFit + pricingFit;
            let remainingSpaces = toBeFilledSpaces - filledSpaces;

            if (remainingSpaces > 0) {

                let lastPopulatedEntityTypeIndex = -1;
                let toBePopulatedEntityType = '';

                const fillEntityTypeArr = Object.values(FillEntityType);
                const n = fillEntityTypeArr.length;

                const viewAllButtonSpaceAvailableMap = {};

                for (let i = 0; i < remainingSpaces; i++) {

                    let entityArr, entityFitNum;

                    // circular access of fillEntityTypeArr 
                    for (
                        let j = lastPopulatedEntityTypeIndex + 1;
                        j < (n + lastPopulatedEntityTypeIndex + 1);
                        j++
                    ) {
                        const circularIndex = j % n;
                        const fillEntityType = fillEntityTypeArr[circularIndex];

                        ({ entityArr, entityFitNum } = getEntityElesArrAndFitValue(fillEntityType));

                        if (entityFitNum !== entityArr?.length) {
                            toBePopulatedEntityType = fillEntityType;
                            lastPopulatedEntityTypeIndex = circularIndex;
                            break;
                        }
                        else if (!viewAllButtonSpaceAvailableMap[fillEntityType]) {
                            remainingSpaces++;
                            viewAllButtonSpaceAvailableMap[fillEntityType] = true;
                        }
                    }

                    if (!toBePopulatedEntityType) break;

                    switch (toBePopulatedEntityType) {
                        case FillEntityType.TIME:
                            timeFit++;
                            const timeViewAllButtonNotVisible = timeEls.length === timeFit;
                            if (
                                timeViewAllButtonNotVisible &&
                                !viewAllButtonSpaceAvailableMap[toBePopulatedEntityType]
                            ) {
                                remainingSpaces++;
                                viewAllButtonSpaceAvailableMap[toBePopulatedEntityType] = true;
                            }
                            break;
                        case FillEntityType.CENTER:
                            centerFit++;
                            const centerViewAllButtonNotVisible = centerEls.length === centerFit;
                            if (
                                centerViewAllButtonNotVisible &&
                                !viewAllButtonSpaceAvailableMap[toBePopulatedEntityType]
                            ) {
                                remainingSpaces++;
                                viewAllButtonSpaceAvailableMap[toBePopulatedEntityType] = true;
                            }
                            break;
                        case FillEntityType.PRICING:
                            pricingFit++;
                            const pricingViewAllButtonNotVisible = pricingEls.length === pricingFit;
                            if (
                                pricingViewAllButtonNotVisible &&
                                !viewAllButtonSpaceAvailableMap[toBePopulatedEntityType]
                            ) {
                                remainingSpaces++;
                                viewAllButtonSpaceAvailableMap[toBePopulatedEntityType] = true;
                            }
                            break;
                    }

                    toBePopulatedEntityType = '';
                }
            }

            newVisibilityMap[batchId] = {
                visibleTimeCount: timeFit,
                visibleCenterCount: centerFit,
                visiblePricingCount: pricingFit
            };
        }

        batchElementsVisibilityMapRef.current = newVisibilityMap;
        setRerenderToggle(prev => !prev); // trigger re-render

    }, [batchDetails]);


    const openModal = (modalType, batchIndex) => {
        setActiveModal(modalType);
        setActiveBatchIndex(batchIndex);
    };

    const closeModal = () => {
        setActiveModal(null);
    };

    function showHideTermsAndConditions() {
        setTermsVisible(!termsVisible);
    }

    const validUpcomingBookingStatues = useRef(Helper.getValidUpcomingBookingStatues());
    const validPastBookingStatues = useRef(Helper.getValidPastBookingStatues());
    const validUpcomingMembershipStatues = useRef(Helper.getValidUpcomingMembershipStatues());
    const validPastMembershipStatues = useRef(Helper.getValidPastMembershipStatues());
    const renderCancellation = payload?.cancellationRules && payload?.cancellationRules?.allow
    const renderReschedule = payload?.reschedulingRules && payload?.reschedulingRules?.allow

    useEffect(() => {
        let confirmBookingPopUp: any = Helper.getUrlParam("confirmBookingPopUp");
        confirmBookingPopUp = Helper.checkUrlParam(confirmBookingPopUp, undefined);
        if (confirmBookingPopUp === "true") {
            setShowBookingConfirmation(true);
            Helper.setUrlParam('confirmBookingPopUp', "");
        }
    }, []);

    useEffect(() => {
        if (firebase?.schoolConfig?.showPackageActivities && entityType === "package")
            dispatch(bookingActivityActions.getAllPackageActivities({ firebase, packageId: payload?.id }));
    }, [payload?.id, entityType, firebase])

    useEffect(() => {
        if (packageReducer.operationType === "BOOKING_UPDATED") {
            dispatch(resetOperationType(null));
            setAfterCancel(true);
        }
    }, [packageReducer.operationType]);

    function isEntity(entityOptionsArr: string[]) {
        return entityOptionsArr.some((entityName) => entityName.toLowerCase() === entityType.toLowerCase());
    }

    // Helper function to extract total credits from credits object (can be number or object with totalPeriods)
    const getTotalCredits = (credits: any): number => {
        if (typeof credits === 'object' && credits !== null && credits.totalPeriods !== undefined) {
            return credits.totalPeriods;
        }
        return typeof credits === 'number' ? credits : 0;
    };

    const totalCredits = getTotalCredits(payload?.credits);

    function membershipHasCreditsLeft() {
        return !(payload.remainingCredits === 0);
    }

    function membershipHasBookedSlots() {
        return (payload.remainingCredits < totalCredits);
    }

    function hasInvoicePaidAmount() {
        return (payload?.paid || payload?.paid === 0);
    }

    function entityHasStatus() {
        return payload?.bookingBasicDetails?.status;
    }

    function entityHasAgeRange(batch) {
        const { ageRange } = batch
        return (ageRange && (ageRange.minYear || ageRange.minMonth || ageRange.maxYear || ageRange.maxMonth))
    }

    function membershipHasPricePackFrequencyAndCredits() {
        return (payload?.pricePackFrequency && payload?.credits);
    }

    function payloadHasUpcomingSlot() {
        switch (entityType) {
            case 'package':
                return payload?.batchDetails?.zerothBatch?.upcomingSlot;
            case 'booking':
            case 'membership':
                return payload?.bookedSlots?.upcomingSlot;
        }
    }

    function getButtonGroup() {
        return (
            <div>
                {
                    afterCancel &&
                    <div style={{ display: "flex", justifyContent: "center", marginTop: 20 }}>
                        <PrefixIconButton
                            title={formatMsg("close")}
                            onClick={() => {
                                setAfterCancel(false)
                            }}
                            borderRadius={"4px"}
                            type={"primary"}
                        />
                    </div>}

                {
                    beforeCancel &&
                    <div style={{ display: "flex", justifyContent: "center", marginTop: 20 }}>
                        <PrefixIconButton
                            title={formatMsg("goBack")}
                            border={true}
                            onClick={() => setBeforeCancel(false)}
                            borderRadius={"4px"}
                        />
                        <PrefixIconButton
                            title={formatMsg("yesCancel")}
                            onClick={() => {
                                dispatch(changeBookingStatus({ firebase, record: payload, confirmOrNot: false }));
                                setBeforeCancel(false);
                            }}
                            borderRadius={"4px"}
                            type={"primary"}
                        />
                    </div>

                }
            </div>
        )
    }

    const images = payload.gallery && payload.gallery.length > 0
        ? [{ original: payload.coverPhoto, type: "image", thumbnail: payload.coverPhoto }, ...payload.gallery.map(img => ({ original: img.path, type: img.type, thumbnail: img.type.includes("video") ? "/images/video_player_placeholder.png" : img.path }))]
        : [{ original: payload.coverPhoto, type: "image", thumbnail: payload.coverPhoto }];


    function getBookedForUser() {
        return (
            <div className='booked-for-user-color-div'>
                {payload?.bookingBasicDetails?.bookedForUser}
            </div>
        )
    }

    function getStartEndTime() {

        let startTime: any = null;
        let endTime: any = null;

        const uniqueTimeSlotsObjList = payload?.bookedSlots?.uniqueTimeSlotsObjList;

        const { bookedBatch, batchDetails } = payload;

        switch (entityType) {
            case 'package':
                if (batchDetails?.zerothBatch?.uniqueTimeSlotsObjList) {
                    startTime = batchDetails.zerothBatch.uniqueTimeSlotsObjList[0].startTime;
                    endTime = batchDetails.zerothBatch.uniqueTimeSlotsObjList[0].endTime;
                }
                break;

            case 'booking':
                if (uniqueTimeSlotsObjList && uniqueTimeSlotsObjList[0]) {
                    startTime = uniqueTimeSlotsObjList[0].startTime;
                    endTime = uniqueTimeSlotsObjList[0].endTime;
                }
                break;

            case 'membership':
                if (bookedBatch) {
                    startTime = bookedBatch.startTime;
                    endTime = bookedBatch.endTime;
                }
                break;
        }

        return (
            isEntity(['booking', 'package']) && (
                <>
                    {
                        (startTime && endTime) ?
                            <span className='font-size-16'>
                                <span>
                                    {`${timeutil.getInstance(startTime).format(Helper.getDefaultDateTimeFormat('time'))} - ${timeutil.getInstance(endTime).format(Helper.getDefaultDateTimeFormat('time'))}`}
                                </span>
                            </span>
                            :
                            null
                    }
                    {
                        (isEntity(['package', 'booking']) && batchDetails?.zerothBatch?.uniqueTimeSlotsObjList?.length > 1) &&
                        <span className='plus-more-option'>
                            {
                                `+${batchDetails?.zerothBatch?.uniqueTimeSlotsObjList?.length - 1} ${Helper.getMoreBatchesText(payload)}`
                            }
                        </span>
                    }
                </>
            )
        )
    }

    function getStartEndDate() {

        let startDate: any = null;
        let endDate: any = null;

        const { bookedBatch, batchDetails } = payload;
        let totalRunningDays = null;

        switch (entityType) {
            case 'package':
                if (batchDetails?.zerothBatch) {
                    startDate = batchDetails.zerothBatch.startDate;
                    endDate = batchDetails.zerothBatch.endDate;
                    totalRunningDays = payload?.batchDetails?.zerothBatch?.totalRunningDays
                }
                break;

            case 'booking':
                const bookingStartDate = payload?.bookedSlots?.startEndDateAndTime?.startDate;
                const bookingEndDate = payload?.bookedSlots?.startEndDateAndTime?.endDate;
                if (bookingStartDate && bookingEndDate) {
                    startDate = bookingStartDate;
                    endDate = bookingEndDate;
                    totalRunningDays = payload?.bookedSlots?.totalRunningDays;
                }
                break;

            case 'membership':
                if (bookedBatch) {
                    startDate = bookedBatch.startDate;
                    endDate = bookedBatch.endDate;
                }
                break;
        }

        return (
            isEntity(['booking', 'package'])
                ? (startDate && endDate) &&
                (<div className='entity-date-time-container'>
                    <div>
                        {timeutil.getInstance(startDate).format(Helper.dateFormat(firebase))}
                        {" - "}
                        {timeutil.getInstance(endDate).format(Helper.dateFormat(firebase))}
                    </div>
                    {/* {
                        totalRunningDays &&
                        <div style={{ fontWeight: '400', paddingLeft: '5px' }}>
                            {`(${totalRunningDays} ${(totalRunningDays === 1) ? formatMsg('small.day') : formatMsg('days')})`}
                        </div>
                    } */}
                    {
                        (isEntity(['package']) && ((payload?.batchDetails?.numberOfBatchesInPackage - 1) > 0)) &&
                        <div className='plus-more-option mt-3'>
                            {
                                `+${payload.batchDetails.numberOfBatchesInPackage - 1} ${(payload.batchDetails.numberOfBatchesInPackage - 1 === 1) ? formatMsg('option') : formatMsg('options')}`
                            }
                        </div>
                    }
                </div>)
                : isEntity(['membership']) &&
                    payloadHasUpcomingSlot() ?
                    (getUpcomingSlotDiv())
                    :
                    <div>
                        <div className='no-upcoming-slot-container'>
                            <span className=''>{formatMsg('noUpcomingSlot')}</span>
                        </div>
                    </div>
        )
    }

    function renderCancellationPolicy() {
        let content = [];

        if (payload) {
            const { cancellationRules, reschedulingRules } = payload;
            if (renderCancellation) {
                if (cancellationRules.refundDetails) {
                    cancellationRules.refundDetails.map((item) => {
                        content.push(
                            <li className='book-fontWeightlight'><span className='book-fontWeight600'>{item.percentage}{"% "}{formatMsg("refund")}{" : "}</span> {formatMsg("refundPolicy", { frequency: item.type, duration: item.value })}</li>)
                    })
                }
            }
            if (renderReschedule) {
                content.push(
                    <li className='book-fontWeightlight'><span className='book-fontWeight600'>{formatMsg("rescheduling")}{" : "}</span> {formatMsg("reschedulingPolicy", { frequency: reschedulingRules.durationType, duration: reschedulingRules.duration })}</li>)
            }
        }
        return <ul className='book-participant-container'> {content} </ul>;
    }

    function getMembershipMainDates() {

        const { label, date } = Helper.getMembershipMainDatesText(payload);

        return (
            <div className='data-container'>
                <div className='data-label'>
                    {formatMsg(label)}:
                </div>
                <div className='data-value'>
                    {timeutil.getInstance(date).format(Helper.dateFormat(firebase))}
                </div>
            </div>
        )
    }

    function getActionButtons() {

        switch (entityType) {
            case 'package':
                const isPackageActive = payload?.status === "ACTIVE";
                const bookNowButton = (
                    <PrefixIconButton
                        title={isPackageActive ? formatMsg("bookNow") : formatMsg("bookingUnavailable")}
                        borderRadius="8px"
                        onClick={() => null}
                        height="40px"
                        className='tab-lap-book-now-btn'
                        type={"primary"}
                        disabled={!isPackageActive}
                    />
                );
                return (
                    <div>
                        {isPackageActive ? (
                            <LinkWrapper
                                href={`/dashboard/book?id=${Helper.getUrlParam('id')}`}
                            >
                                {bookNowButton}
                            </LinkWrapper>
                        ) : (
                            bookNowButton
                        )}
                    </div>
                )
            case 'booking':
                return (
                    <div>
                        <PrefixIconButton
                            type={"primary"}
                            title={formatMsg("viewSchedule")}
                            borderRadius="8px"
                            height="40px"
                            onClick={() => router.push(`/dashboard/calendar?entityType=booking&id=${payload?.bookingBasicDetails?.id}&centerId=` + Helper.getUrlParam("centerId"))}
                        />
                    </div>
                )
            case 'membership':
                if (membershipHasCreditsLeft() && payload.pricePackFrequency !== "ENTIRE_PACKAGE_DURATION") {
                    if (
                        Helper.entityHasValidStatus(
                            validUpcomingMembershipStatues.current,
                            payload?.bookingBasicDetails?.status
                        )
                    ) {
                        return (
                            <div>
                                <PrefixIconButton
                                    type={"primary"}
                                    title={formatMsg("bookSlots")}
                                    borderRadius="8px"
                                    onClick={() => {
                                        setRescheduleModal(payload?.bookingBasicDetails?.id)
                                    }}
                                    height="40px"
                                />
                            </div>
                        )
                    }
                    else return null;
                }
                else {
                    return (
                        <div>
                            <PrefixIconButton
                                type={"primary"}
                                title={formatMsg("viewSchedule")}
                                borderRadius="8px"
                                height="40px"
                                onClick={() => router.push(`/dashboard/calendar?entityType=booking&id=${payload?.bookingBasicDetails?.id}&centerId=` + Helper.getUrlParam("centerId"))}
                            />
                        </div>
                    )
                }
        }
    }


    function getUpcomingSlotDiv() {

        let upcomingSlotObj = null;

        switch (entityType) {
            case 'package':
                upcomingSlotObj = payload?.batchDetails?.zerothBatch?.upcomingSlot;
                break;
            case 'booking':
            case 'membership':
                upcomingSlotObj = payload?.bookedSlots?.upcomingSlot;
                break;
        }

        if (upcomingSlotObj) {
            return (
                <div>
                    <div className={`upcoming-slot-container ${isEntity(['package', 'booking']) ? 'mb-8' : ''}`}>
                        <span className='upcoming-slot-heading'>{formatMsg('upcomingSlot')}:</span>
                        <span className='upcoming-slot-date-time'>
                            {timeutil.getInstance(upcomingSlotObj.date).format(Helper.dateFormat(firebase))}
                            {
                                (upcomingSlotObj.startTime && upcomingSlotObj.endTime) ?
                                    `, ${timeutil.getInstance(upcomingSlotObj.startTime).format(Helper.getDefaultDateTimeFormat('time'))} - ${timeutil.getInstance(upcomingSlotObj.endTime).format(Helper.getDefaultDateTimeFormat('time'))}`
                                    :
                                    null
                            }
                        </span>
                    </div>
                </div>
            )
        }
    }

    function getMobileViewBottomStickyDiv() {

        switch (entityType) {
            case 'package':
                const isPackageActive = payload?.status === "ACTIVE";
                const mobileBookNowButton = (
                    <PrefixIconButton
                        type={"primary"}
                        title={isPackageActive ? formatMsg("bookNow") : formatMsg("bookingUnavailable")}
                        width="100%"
                        maxWidth="350px"
                        height="38px"
                        outerDivWidth="100%"
                        marginTop="5px"
                        prefixRight={"9px"}
                        onClick={() => null}
                        borderRadius={'8px'}
                        disabled={!isPackageActive}
                    />
                );
                return (
                    <div className='mobile-book-now'>
                        <div className='package-pricing'>
                            {
                                payload?.cheapestPrice && payload.cheapestFrequency &&
                                <div className='cheapest-price-container mb-25 font-size-16'>
                                    <span className='cheapest-price-div'>
                                        {Helper.getPricingPackName2({ frequencyValue: payload.cheapestFrequency, frequency: payload.cheapestFrequency, feeAmount: payload.cheapestPrice }, firebase)}
                                    </span>
                                    <span className='onwards-text'>
                                        {formatMsg('onwards')}
                                    </span>
                                </div>
                            }
                        </div>
                        {isPackageActive ? (
                            <LinkWrapper
                                href={`/dashboard/book?id=${payload?.id}`}
                                aTagStyle={{ width: '50%' }}
                            >
                                {mobileBookNowButton}
                            </LinkWrapper>
                        ) : (
                            <div style={{ width: '50%' }}>
                                {mobileBookNowButton}
                            </div>
                        )}
                    </div>
                )
        };
    }

    function getEntityBasicDetails1stDivForMobileScreen() {

        return (
            <div className='mobile-sticky-bar'>
                <div className='package-name-label'>
                    {payload.name}
                    {payload?.bookedInCenter?.name ? (" - " + payload.bookedInCenter.name) : null}
                </div>
                <div className='entity-start-end-date'>
                    <div className='calendar-icon-container'>
                        <img src="/images/calender.png" className="calendar-icon" alt="calenderIcon" />
                    </div>
                    {
                        getStartEndDate()
                    }
                </div>
                {/* {isEntity(['package']) && entityHasAgeRange() && (
                    <div className='age-range-container'>
                        <img src="/images/ageIcon.png" alt="Age Icon" className='age-range-icon' />
                        <div className='age-range-text'> {payload.ageRange ? Helper.renderAgeRange(payload.ageRange) : null}</div>
                    </div>
                )} */}
                <div className='location-container'>
                    {
                        isEntity(['package']) && (payload?.centersList?.length === 1) &&
                        <div className='location-display-name'>
                            <img src="/images/location.png" alt="Location Icon" className='location-icon' />
                            {payload?.centersList?.map((item) => item.name)?.join(", ")}
                        </div>
                    }
                    {
                        isEntity(['booking', 'membership']) &&
                        <div className='location-display-name'>
                            <img src="/images/location.png" alt="Location Icon" className='location-icon' />
                            {payload?.bookedInCenter?.name}
                        </div>
                    }
                </div>
                {/* <div>
                    {
                        (isEntity(['package', 'booking']) && payloadHasUpcomingSlot()) &&
                        getUpcomingSlotDiv()
                    }
                </div> */}
            </div>
        );
    }

    function entityHasWeekDays() {

        switch (entityType) {
            case 'package':
                return payload?.batchDetails?.zerothBatch?.weekDays;
            case 'booking':
            case 'membership':
                return payload?.bookedSlots?.weekDays;
        }
    }

    function getWeekDaysDiv() {

        let weekDays = null;

        switch (entityType) {
            case 'package':
                weekDays = payload?.batchDetails?.zerothBatch?.weekDays;
                break;
            case 'booking':
            case 'membership':
                weekDays = payload?.bookedSlots?.weekDays;
                break;
        }

        return (
            (weekDays?.length > 0) &&
            <div className=''>
                {Helper.getWeekDaysDisplayDiv(weekDays, 'week-days-line', 'week-day-cell')}
            </div>
        )
    }


    const getApproveReject = (payload) => {
        let options: any = [];

        if (payload?.bookingBasicDetails?.status && (payload.bookingBasicDetails.status !== "CANCELLED")) {
            const currentTime = timeutil.getInstance();
            const { startDate } = payload.bookingBasicDetails;

            const getDeadlineTime = (startDate, duration, durationType) => {
                let deadline = timeutil.getInstance(startDate);

                if (durationType === "hours") {
                    deadline = deadline.subtract(duration, "hour");
                } else if (durationType === "days") {
                    deadline = deadline.subtract(duration, "day");
                }

                return deadline;
            };


            if (payload.reschedulingRules.allow) {
                const rescheduleDeadline = getDeadlineTime(startDate, payload.reschedulingRules.duration, payload.reschedulingRules.durationType);
                if (currentTime.isBefore(rescheduleDeadline)) {
                    if (payload.bookingBasicDetails.status != NewBookingStatuses.CONFIRMATION_PENDING && payload.bookingBasicDetails.status != NewBookingStatuses.WAITLISTED) options.push({
                        image: "/images/RescheduleIcon.png",
                        title: formatMsg("reschedule"),
                        action: () => {
                            setIsPopupOpen(undefined);
                            setOpenRescheduleModal(payload.bookingBasicDetails.id);
                        }
                    });
                }
            }

            if (payload.cancellationRules.allow) {
                const cancelDeadline = getDeadlineTime(startDate, payload.cancellationRules.duration, payload.cancellationRules.durationType);
                if (currentTime.isBefore(cancelDeadline)) {
                    options.push({
                        image: "/images/Reject.png",
                        title: formatMsg("cancel"),
                        action: () => {
                            setIsPopupOpen(undefined);
                            setBeforeCancel(true);
                        }
                    });
                }
            }
        }

        return options;
    };


    function getCancellationReschedulingOptions() {

        return getApproveReject(payload)?.length ? (
            <div className="displayFlex">
                <CustomPopoverOptions
                    imgSrc={"/images/dot.png"}
                    imgWidth={"5px"}
                    imgHeight={"25px"}
                    open={isPopupOpen}
                    setOpen={setIsPopupOpen}
                    recordId={payload.id}
                    options={getApproveReject(payload)}
                />
            </div>
        ) : null;
    }

    const getRefundPolicy = (cancellationRules, bookingStartDate) => {
        const currentTime = timeutil.getInstance();
        const timeDifference = timeutil.getInstance(bookingStartDate).diff(currentTime, "hours");

        let refundPercentage = 0;
        cancellationRules.refundDetails.forEach((rule) => {
            let ruleTime = rule.type === "days" ? rule.value * 24 : rule.value;
            if (timeDifference >= ruleTime) {
                refundPercentage = Math.max(refundPercentage, rule.percentage);
            }
        });

        return `You will receive a ${refundPercentage}% refund.`;
    };

    const getCancellationNotice = (cancellationRules) => {
        return `Cancel at least ${cancellationRules.duration} ${cancellationRules.durationType} in advance to avoid charges.`;
    };



    function getEntityBasicDetails1stDivForLapTabScreen() {
        return (
            <div
                className='entity-basic-details'
                style={{ justifyContent: header ? "space-around" : "space-between" }}
            >
                <div className='lap-tab-sticky-bar-content'>
                    <div className='first-row-detail-view'>
                        <div className='package-name-container'>
                            <div className='package-name-label'>
                                {payload?.name}
                                {payload?.bookedInCenter?.name ? (" - " + payload.bookedInCenter.name) : null}
                            </div>
                            {
                                ((isEntity(['booking', 'membership'])) && entityHasStatus()) &&
                                <div
                                    className='status-name-container'
                                    style={{
                                        backgroundColor: Helper.getBookingStatusColor(payload.bookingBasicDetails.status)
                                    }}
                                >
                                    {formatMsg(payload.bookingBasicDetails.status)}
                                </div>
                            }
                            {
                                (isEntity(['membership']) &&
                                    membershipHasBookedSlots() &&
                                    membershipHasCreditsLeft() &&
                                    Helper.entityHasValidStatus(
                                        validUpcomingMembershipStatues.current,
                                        payload?.bookingBasicDetails?.status
                                    )) &&
                                <div className='view-schedule-text'>
                                    {"("}{formatMsg('viewSchedule')}{")"}
                                </div>
                            }
                        </div>
                    </div>

                    <div className='second-row-detail-view'>

                        <div className='second-row-col-1'>
                            <div className='entity-start-end-date'>
                                <div className='calendar-icon-container'>
                                    <img src="/images/calender.png" className="calendar-icon" alt="calenderIcon" />
                                </div>
                                <div>
                                    {
                                        getStartEndDate()
                                    }
                                </div>
                            </div>

                            {
                                isEntity(['package', 'booking']) &&
                                <div className='entity-start-end-date'>
                                    <div className='calendar-icon-container'>
                                        <img src="/images/clock.png" className="calendar-icon" alt="calenderIcon" />
                                    </div>
                                    <div className='entity-time-range'>
                                        {
                                            getStartEndTime()
                                        }
                                    </div>
                                </div>
                            }
                        </div>

                        {/* {isEntity(['package']) && entityHasAgeRange() && (
                            <div className='age-range-container'>
                                <img src="/images/ageIcon.png" alt="Age Icon" className='age-range-icon' />
                                <div className='age-range-text'> {payload.ageRange && Helper.renderAgeRange(payload.ageRange)}</div>
                            </div>
                        )} */}

                        {
                            isEntity(['package']) && Boolean(payload?.cheapestPrice) &&
                            <div className='package-price-container'>
                                <div className='dollar-icon-container'>
                                    <img src="/images/dollarCoinIcon.png" className="dollar-icon" alt="dollarIcon" />
                                </div>
                                <div className='onwards-text-detail-view'>
                                    {`${Helper.getCurrency(firebase)}${payload.cheapestPrice} ` + formatMsg('onwards')}
                                </div>
                            </div>
                        }

                        {
                            isEntity(['booking', 'membership']) && (
                                <div className='user-container'>
                                    <div className='user-color-div'>
                                        <img src="/images/userIcon.png" className="user-icon" alt="userIcon" />
                                        {
                                            getBookedForUser()
                                        }
                                    </div>
                                </div>
                            )
                        }
                        {/* {
                            isEntity(['booking', 'membership']) &&
                            hasInvoicePaidAmount() &&
                            <div className='invoice-paid-amount-container'>
                                <div className='dollar-icon-container'>
                                    <img src="/images/dollarCoinIcon.png" className="dollar-icon" alt="dollarIcon" />
                                </div>
                                <div>
                                    {Helper.getCurrency(firebase)}
                                    {payload.paid || 0}
                                    {" "}{formatMsg("label.paid")}
                                </div>
                                <div className='view-invoice'>
                                    {"("}{formatMsg('viewInvoice')}{")"}
                                </div>
                            </div>
                        } */}
                        {
                            entityHasWeekDays() && getWeekDaysDiv()
                        }

                        {
                            (isEntity(['booking']) &&
                                payload?.bookingBasicDetails?.status?.toLowerCase() === 'cancelled' &&
                                payload?.bookingBasicDetails?.cancelledOn) &&
                            <div className='second-row-detail-view'>
                                <div className='data-container'>
                                    <div className='data-label'>
                                        {formatMsg('cancelledOn')}:
                                    </div>
                                    <div className='data-value'>
                                        {timeutil.getInstance(payload.bookingBasicDetails.cancelledOn).format(Helper.dateFormat(firebase))}
                                    </div>
                                </div>
                            </div>
                        }
                    </div>

                    {
                        (isEntity(['membership'])) ?
                            <div className='third-row-detail-view'>
                                {
                                    (membershipHasPricePackFrequencyAndCredits()) && (
                                        <div className='data-container'>
                                            <div className='data-label'>
                                                {formatMsg('membershipType')}:
                                            </div>
                                            <div className='data-value'>
                                                {`${totalCredits} ${formatMsg(payload.pricePackFrequency)} ${formatMsg('plan')}`}
                                            </div>
                                        </div>
                                    )
                                }
                                {
                                    Boolean(payload.remainingCredits || payload.remainingCredits >= 0) &&
                                    <div className='data-container'>
                                        <div className='data-label'>
                                            {formatMsg("remainingFreqToBeBooked", { frequency: Helper.getSubFrequency(payload?.pricePackFrequency) })}:
                                        </div>
                                        <div className='data-value'>
                                            {payload.remainingCredits}
                                        </div>
                                    </div>
                                }
                                {
                                    getMembershipMainDates()
                                }
                            </div>
                            :
                            null
                    }
                    <div>
                        {
                            (isEntity(['booking', 'package']) && payloadHasUpcomingSlot()) &&
                            getUpcomingSlotDiv()
                        }
                    </div>
                </div>

                <div className='buttons-container'>
                    {
                        getActionButtons()
                    }
                    {
                        isEntity(['booking']) &&
                        getCancellationReschedulingOptions()
                    }
                </div>
            </div>
        )
    }

    function getEntityBasicDetails2ndDiv() {

        return (
            <div style={{ display: "flex", alignItems: "center", gap: "24px", marginLeft: "10px", marginTop: "5px" }}>
                <div className='location-div'>
                    <img src="/images/location.png" alt="Location Icon" className='location-icon' />
                    <div className='location-container'>
                        {
                            isEntity(['package']) && payload?.centersList?.length >= 1 &&
                            <div className='location-display-name'>
                                {
                                    isEntity(['package']) && payload?.centersList?.map((item) => item.name)?.join(", ")
                                }
                            </div>
                        }
                        {
                            isEntity(['booking', 'membership']) &&
                            <div className='location-display-name'>
                                {payload.bookedInCenter?.name}
                            </div>
                        }

                    </div>
                </div>
                {
                    isEntity(['booking', 'membership']) && payload?.bookedBatch?.name &&
                    <div className='booked-batch-name'>
                        <div className='batch-icon-container'>
                            <img src="/images/batchIcon.png" className="batch-icon" alt="batchIcon" />
                        </div>
                        <div>
                            {payload?.bookedBatch?.name}
                        </div>
                    </div>
                }
            </div>
        )
    }

    function getDescriptionOfPackageDiv() {

        return (
            <Col
                xxl={15} xl={17} lg={19} md={21} sm={22} xs={22}
                style={styles.descriptionContainer}
            >
                <div className='description-box-content'>
                    <div className='about-heading'>{formatMsg("about")}</div>
                    <div
                        dangerouslySetInnerHTML={{
                            __html: payload.description
                        }}
                    />
                </div>
            </Col>
        )
    }

    function getCancellationAndReschedulingRules() {

        return (
            <Col
                xxl={15} xl={17} lg={19} md={21} sm={22} xs={22}
                style={styles.cancellationReschedulingPolicy}>
                <div className='description-box-content'>
                    <div className='cancellation-policy-heading'>{formatMsg("cancellationReschedulingPolicy")}</div>
                    <div>
                        {renderCancellationPolicy()}
                    </div>
                </div>
            </Col>
        )
    }

    function getTermsAndConditionsLabel() {

        return (
            <Col xxl={15} xl={17} lg={19} md={21} sm={22} xs={22} className="terms-and-conditions-container">
                <span
                    className='view-text'
                >
                    <span>
                        {formatMsg("view")}
                    </span>

                    <span
                        onClick={showHideTermsAndConditions}
                        className='terms-conditions-text'
                    >
                        {formatMsg("label.termsAndConditions")}
                    </span>
                </span>
            </Col>
        )
    }

    function getSectionDivider() {
        return (
            <div className="divider adjust-divider">
                <Divider />
            </div>
        )
    }

    const getModalData = (modalType, batchIndex) => {

        const batch = batchDetails?.[batchIndex];

        if (batch) {
            switch (modalType) {
                case 'pricing':
                    return (
                        <div className={batchStyles.modalContainer}>
                            {
                                <div className={batchStyles.list}>
                                    {batch.pricingPackData.map((pricePack, index) => (
                                        <li key={index} className={batchStyles.infoValue}>
                                            {getPricePackName(pricePack)}
                                        </li>
                                    ))}
                                </div>
                            }
                        </div>
                    )
                case 'centers':
                    return (
                        <div className={batchStyles.modalContainer}>
                            {
                                <div className={batchStyles.list}>
                                    {
                                        batch.centersList.map((centers, index) => (
                                            <li key={index} className={batchStyles.infoValue}>
                                                {centers.name}
                                            </li>
                                        ))
                                    }
                                </div>
                            }
                        </div>
                    );
                case 'timings':
                    return (
                        <div className={batchStyles.modalContainer}>
                            {getDateTimeSlotsHelper(batch, 'modal')}
                        </div>
                    )
                case 'dates':
                    return (
                        <div className={batchStyles.modalContainer}>
                            {
                                <div className={batchStyles.list}>
                                    {
                                        batch.dayDateTimeSlotsMap.map(([dayDate, _]) => {
                                            return (
                                                <li key={dayDate} className={batchStyles.infoValue}>
                                                    {timeutil.inFormat(timeutil.getInstance(dayDate, 'DD-MM-YYYY').valueOf(), Helper.dateFormat(firebase))}
                                                </li>
                                            )
                                        })
                                    }
                                </div>

                            }
                        </div>
                    )
                default:
                    return [];
            }
        }
    };

    function getPricePackName(pricePack) {
        return (
            <>
                <span className={batchStyles.price}>
                    {Helper.getCurrency(firebase) + pricePack.feeAmount}
                </span>
                <span className={batchStyles.frequency}>
                    {" "}
                    {
                        Helper.getPricingPackName2(pricePack, firebase)
                            ?.split(/\s(.+)/)?.[1]
                    }
                </span>
            </>
        )
    }

    function getDayDateTimeSlotsDiv(batchType, dayDate, timeSlotsArr, viewType: 'card' | 'modal', index) {

        const dayDateDiv = batchType?.toLowerCase() === 'recurring'
            ? formatMsg(dayDate || 'MONDAY')
            : batchType?.toLowerCase() === 'specific'
                ? timeutil.inFormat(timeutil.getEpoch(dayDate, 'DD-MM-YYYY'), Helper.dateFormat(firebase))
                : '';

        if (timeSlotsArr?.length) {

            switch (viewType) {
                case 'modal':
                    return (
                        <li
                            key={dayDate}
                            className={`${batchStyles.infoValue} ${batchStyles.customLiPadding}`}
                        >
                            <span className={batchStyles.modalDayDateHeader}>
                                {dayDateDiv}
                            </span>
                            <div className={`${batchStyles.nestedList} ${batchStyles.discUl}`}>
                                {
                                    timeSlotsArr.map((obj) => {
                                        return (
                                            <li className={batchStyles.infoValue}>
                                                {timeutil.inFormat(obj.startTime, Helper.timeFormat(firebase))}
                                                {" - "}
                                                {timeutil.inFormat(obj.endTime, Helper.timeFormat(firebase))}
                                            </li>
                                        )
                                    })
                                }
                            </div>
                        </li>
                    )
                case 'card':
                    const tempObj = timeSlotsArr[0];
                    return (
                        <div
                            key={dayDate}
                            className={batchStyles.infoValue}
                        >
                            <span>
                                {dayDateDiv}
                            </span>
                            {' | '}
                            <span className={batchStyles.infoValue}>
                                {timeutil.inFormat(tempObj.startTime, Helper.timeFormat(firebase))}
                                {" - "}
                                {timeutil.inFormat(tempObj.endTime, Helper.timeFormat(firebase))}
                                {' '}
                                {
                                    timeSlotsArr?.length > 1
                                        ? <span
                                            className={batchStyles.plusMoreTimes}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                openModal('timings', index);
                                            }}
                                        >
                                            +{timeSlotsArr.length - 1}{' '}{formatMsg('more')}
                                        </span>
                                        : null
                                }
                            </span>
                        </div>
                    )
            }
        }
    }

    function getSameTimeSlotsDiv(
        timeObj: { startTime: number, endTime: number },
        viewType: 'card' | 'modal'
    ) {
        switch (viewType) {
            case 'card':
                return (
                    <div className={batchStyles.infoValue}>
                        {timeutil.inFormat(timeObj.startTime, Helper.timeFormat(firebase))}
                        {" - "}
                        {timeutil.inFormat(timeObj.endTime, Helper.timeFormat(firebase))}
                    </div>
                )
            case 'modal':
                return (
                    <li className={batchStyles.infoValue}>
                        {timeutil.inFormat(timeObj.startTime, Helper.timeFormat(firebase))}
                        {" - "}
                        {timeutil.inFormat(timeObj.endTime, Helper.timeFormat(firebase))}
                    </li>
                )
        }
    }

    function isSameTimingsBatch(batch: Record<string, any>) {
        return (batch?.sameTimings && Boolean(batch?.uniqueTimeSlotsObjList?.length));
    }

    function isDifferentTimingsBatch(batch: Record<string, any>) {
        return Boolean(batch?.dayDateTimeSlotsMap?.length);
    }

    function getDateTimeSlotsHelper(batch, viewType: 'card' | 'modal', index?: number) {

        let uniqueTimeSlotsObjList = [];
        let dayDateTimeSlotsMap = [];

        const timeVisibilityLimit = batchElementsVisibilityMapRef.current?.[batch.id]?.visibleTimeCount || 3;

        switch (viewType) {
            case 'card':
                uniqueTimeSlotsObjList = batch?.uniqueTimeSlotsObjList?.slice(0, timeVisibilityLimit) || [];
                dayDateTimeSlotsMap = batch?.dayDateTimeSlotsMap?.slice(0, timeVisibilityLimit) || [];
                break;
            case 'modal':
                uniqueTimeSlotsObjList = batch?.uniqueTimeSlotsObjList || [];
                dayDateTimeSlotsMap = batch?.dayDateTimeSlotsMap || [];
                break;
        }

        return (
            (isSameTimingsBatch(batch))
                ? <div className={viewType === 'modal' ? batchStyles.list : ''}>
                    {
                        uniqueTimeSlotsObjList.map((timeObj) => {
                            return getSameTimeSlotsDiv(timeObj, viewType)
                        })
                    }
                    {
                        viewType === 'card' &&
                        batch?.uniqueTimeSlotsObjList?.length > timeVisibilityLimit && (
                            <div
                                className={batchStyles.viewAllLink}
                                onClick={(e) => {
                                    e.preventDefault();
                                    openModal('timings', index);
                                }}
                            >
                                {formatMsg("viewAllTimings")}
                            </div>
                        )
                    }
                </div>
                : isDifferentTimingsBatch(batch) && <div className={viewType === 'modal' ? batchStyles.list : ''}>
                    {
                        dayDateTimeSlotsMap
                            .map(([dayDate, timeSlotsArr]) => {
                                return getDayDateTimeSlotsDiv(batch.type, dayDate, timeSlotsArr, viewType, index)
                            })
                    }
                    {
                        viewType === 'card' &&
                        (batch?.dayDateTimeSlotsMap?.length > timeVisibilityLimit ||
                            batch?.dayDateTimeSlotsMap?.some(([dayDate, timeSlotsArr]) => timeSlotsArr?.length > 1)) && (
                            <div
                                className={batchStyles.viewAllLink}
                                onClick={(e) => {
                                    e.preventDefault();
                                    openModal('timings', index);
                                }}
                            >
                                {formatMsg("viewAllTimings")}
                            </div>
                        )
                    }
                </div>
        )
    }

    const scrollWidth = typeof window !== 'undefined'
        ? window.innerWidth >= 525
            ? 417.5
            : window.innerWidth >= 485
                ? 378
                : window.innerWidth >= 400
                    ? (window.innerWidth - 30)
                    : window.innerWidth >= 360
                        ? (window.innerWidth - 25)
                        : (window.innerWidth - 26)
        : 0;

    const scrollLeft = () => {
        if (cardsContainerRef.current) {
            cardsContainerRef.current
                .scrollBy({
                    left: -scrollWidth,
                    behavior: "smooth"
                });
        }
    };

    const scrollRight = () => {
        if (cardsContainerRef.current) {
            cardsContainerRef.current
                .scrollBy({
                    left: scrollWidth,
                    behavior: "smooth"
                });
        }
    };

    const checkArrows = () => {

        const container = cardsContainerRef.current;
        if (!container) return;

        const { scrollLeft, scrollWidth, clientWidth } = container;

        setShowLeftArrow(scrollLeft > 0);
        setShowRightArrow(scrollLeft + clientWidth < scrollWidth);
    };

    useEffect(() => {
        const container = cardsContainerRef.current;

        if (container) {
            container.addEventListener('scroll', checkArrows);
            checkArrows(); // check on mount
        }

        return () => {
            if (container) {
                container.removeEventListener('scroll', checkArrows);
            }
        };
    }, [batchDetails]);

    const showArrows = (batchDetails?.length > 2 || (batchDetails?.length === 2 && window?.innerWidth < 1021));


    function getBatchWhenLengthTwoOrMore() {
        return (
            <div className={batchStyles.batchDetailsContainer}>
                <div className={batchStyles.newPackageName}>
                    {payload?.name}
                </div>
                {
                    showLeftArrow && showArrows &&
                    <LeftOutlined
                        onClick={() => scrollLeft()}
                        className={batchStyles.leftScrollBtn}
                    />
                }
                <div
                    className={`${batchStyles.batchCardsContainer} ${batchStyles.hideScrollbar}`}
                    ref={cardsContainerRef}
                >
                    {
                        batchDetails.map((batch, index) => {

                            const centerVisibilityLimit = batchElementsVisibilityMapRef.current
                                ?.[batch.id]
                                ?.visibleCenterCount || 3;

                            const pricingVisibilityLimit = batchElementsVisibilityMapRef.current
                                ?.[batch.id]
                                ?.visiblePricingCount || 3;

                            return (
                                <div
                                    className={`${batchDetails?.length === 2
                                        ? batchStyles.batchTwoCard
                                        : batchStyles.batchCard
                                        }`}
                                    key={index}
                                >
                                    <div>
                                        <div>
                                            <div className={batchStyles.secondRow}>
                                                <div className={batchStyles.batchHeading}>
                                                    <Tooltip
                                                        title={batch.batchName}
                                                    >
                                                        {batch.batchName}
                                                    </Tooltip>
                                                </div>
                                                <div className={batchStyles.bookNowContainer}>
                                                    {(() => {
                                                        const isPackageActive = payload?.status === "ACTIVE";
                                                        const batchBookNowButton = (
                                                            <PrefixIconButton
                                                                type='primary'
                                                                title={isPackageActive ? formatMsg("bookNow") : formatMsg("bookingUnavailable")}
                                                                border={true}
                                                                borderColor='var(--theme-color)'
                                                                borderRadius="8px"
                                                                onClick={() => null}
                                                                height="40px"
                                                                width={"100%"}
                                                                disabled={!isPackageActive}
                                                            />
                                                        );
                                                        return isPackageActive ? (
                                                            <LinkWrapper
                                                                href={`/dashboard/book?id=${Helper.getUrlParam('id')}&batchId=${batch.id}&centerId=${Helper.getUrlParam("centerId") || getItem("centerId")}`}
                                                                style={{ height: '100%' }}
                                                            >
                                                                {batchBookNowButton}
                                                            </LinkWrapper>
                                                        ) : (
                                                            <div style={{ height: '100%' }}>
                                                                {batchBookNowButton}
                                                            </div>
                                                        );
                                                    })()}
                                                </div>
                                            </div>
                                            {
                                                !!entityHasAgeRange(batch) &&
                                                <div className={batchStyles.thirdRow}>
                                                    <div className={batchStyles.ageRange}>
                                                        <img
                                                            className={batchStyles.ageRangeImg}
                                                            src={'/images/ageIcon.png'}
                                                        />
                                                        <div className={batchStyles.ageLabel}>
                                                            {batch.ageRange && Helper.renderAgeRange(batch.ageRange)}
                                                        </div>
                                                    </div>
                                                </div>
                                            }

                                            <div className={batchStyles.greyDivider} />
                                        </div>

                                        <div className={batchStyles.infoRow}>
                                            <div className={batchStyles.iconContainer}>
                                                <img
                                                    src="/images/calendar_light.png"
                                                    className={batchStyles.calendarIcon}
                                                    alt="calenderIcon"
                                                />
                                            </div>
                                            <div className={batchStyles.infoContent}>
                                                <div className={batchStyles.infoLabel}>{formatMsg("date")}</div>
                                                <div className={batchStyles.infoValue}>
                                                    {timeutil.inFormat(batch.startDate, Helper.dateFormat(firebase))}
                                                    {" - "}
                                                    {timeutil.inFormat(batch.endDate, Helper.dateFormat(firebase))}
                                                    {" (" + batch.totalRunningDays + ' ' + formatMsg((batch.totalRunningDays <= 1) ? 'small.day' : 'days') + ")"}
                                                </div>
                                                {
                                                    batch.type === 'specific' &&
                                                    <div
                                                        className={batchStyles.viewAllLink}
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            openModal('dates', index);
                                                        }}
                                                    >
                                                        {formatMsg("viewDates")}
                                                    </div>
                                                }
                                            </div>
                                        </div>

                                        {
                                            batch.weekDays &&
                                            <div className={`${batchStyles.infoRow} ${batchStyles.weekDays}`}>
                                                {
                                                    Helper.getWeekDaysDisplayDiv(
                                                        batch.weekDays,
                                                        batchStyles.weekDaysContainer,
                                                        '',
                                                        {
                                                            backgroundColor: 'var(--lightest-theme-color)',
                                                            color: 'var(--normalized-theme-color)',
                                                            border: `0.5px solid var(--normalized-theme-color)`
                                                        }
                                                    )
                                                }
                                            </div>
                                        }

                                        <div className={batchStyles.infoRow}>
                                            <div className={batchStyles.iconContainer}>
                                                <img
                                                    src="/images/clock.png"
                                                    className={batchStyles.calendarIcon}
                                                    alt="calenderIcon"
                                                />
                                            </div>
                                            <div className={batchStyles.infoContent}>
                                                <div className={batchStyles.infoLabel}>
                                                    {formatMsg("time")}
                                                </div>
                                                <div>
                                                    {getDateTimeSlotsHelper(batch, 'card', index)}
                                                </div>
                                            </div>
                                        </div>

                                        {
                                            Boolean(batch.centersList?.length) &&
                                            <div className={batchStyles.infoRow}>
                                                <div className={batchStyles.iconContainer}>
                                                    <img
                                                        src="/images/locationPin.png"
                                                        className={batchStyles.locationPin}
                                                        alt="dollarIcon"
                                                    />
                                                </div>
                                                <div className={batchStyles.infoContent}>
                                                    <div className={batchStyles.infoLabel}>{formatMsg("centers")}</div>
                                                    <div className={batchStyles.infoValue}>
                                                        {
                                                            batch.centersList.slice(0, centerVisibilityLimit).map((centersObj, index) => {
                                                                return (
                                                                    <div key={index}>
                                                                        {centersObj.name} <br />
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                    {
                                                        (batch.centersList.length > centerVisibilityLimit) &&
                                                        <div
                                                            className={batchStyles.viewAllLink}
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                openModal('centers', index);
                                                            }}
                                                        >
                                                            {formatMsg("viewAllCenters")}
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        }

                                        <div className={batchStyles.infoRow}>
                                            <div className={batchStyles.iconContainer}>
                                                <img
                                                    src="/images/dollar_new.png"
                                                    className={batchStyles.dollarIcon}
                                                    alt="dollarIcon"
                                                />
                                            </div>
                                            <div className={batchStyles.infoContent}>
                                                <div className={batchStyles.infoLabel}>
                                                    {formatMsg("pricing")}
                                                </div>
                                                {batch.pricingPackData.length > 0 && (
                                                    <>
                                                        {batch.pricingPackData.slice(0, pricingVisibilityLimit).map((pricePack, index) => (
                                                            <div key={index} className={batchStyles.infoValue}>
                                                                {getPricePackName(pricePack)}
                                                            </div>
                                                        ))}
                                                        {batch.pricingPackData.length > pricingVisibilityLimit && (
                                                            <div
                                                                className={batchStyles.viewAllLink}
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    openModal('pricing', index);
                                                                }}
                                                            >
                                                                {formatMsg("viewAllPricing")}
                                                            </div>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                        )
                    }
                </div>
                {
                    showRightArrow && showArrows &&
                    <RightOutlined
                        onClick={() => scrollRight()}
                        className={batchStyles.rightScrollBtn}
                    />
                }
            </div>
        )
    }

    return (
        <Box
            style={{ padding: "20px 0px" }}
            className={isEntity(['package']) && (batchDetails?.length >= 2) ? 'custom-detail-box' : ''}
        >
            <SpinWrapper
                spinning={
                    accountPackageReducer.isLoading
                }
            >
                <Row align={"middle"} justify={"center"}>
                    <Col xs={24} className='margin-top-fill'>
                        <Affix
                            offsetTop={49}
                        >
                            {
                                getEntityBasicDetails1stDivForMobileScreen()
                            }
                        </Affix>
                    </Col>

                    <Col xxl={15} xl={17} lg={19} md={21} sm={22} xs={22} className="gallery-container" >
                        <GalleryWithCoverPhotos images={images} />
                    </Col>

                    {isEntity(['package']) && (batchDetails?.length >= 2) && (
                        <Col xxl={15} xl={17} lg={19} md={21} sm={22} xs={22} >
                            {getBatchWhenLengthTwoOrMore()}
                        </Col>
                    )}
                    {
                        (isEntity(['booking', 'membership']) ||
                            isEntity(['package']) && batchDetails?.length === 1) &&
                        <Col xxl={header ? 24 : 15} xl={header ? 24 : 17} lg={header ? 24 : 19} md={header ? 24 : 21} sm={header ? 24 : 22} xs={header ? 24 : 22} >
                            <Affix
                                offsetTop={53}
                                onChange={e => setHeader(e)}
                            >
                                <div className="lap-tab-sticky-bar">
                                    {
                                        getEntityBasicDetails1stDivForLapTabScreen()
                                    }
                                    {
                                        !header &&
                                        getSectionDivider()
                                    }
                                    {
                                        !header &&
                                        getEntityBasicDetails2ndDiv()
                                    }
                                </div>
                            </Affix>
                        </Col>
                    }
                    {isEntity(['package']) && firebase?.schoolConfig?.showPackageActivities && Boolean(bookingActivity.packageActivities?.length) && (
                        <Col
                            xxl={15} xl={17} lg={19} md={21} sm={22} xs={22}
                            style={{ ...styles.descriptionContainer, marginBottom: payload?.description ? 0 : 28 }}
                        >
                            <div className='description-box-content'>
                                <div className='about-heading'>{formatMsg("sidebar.activities")}</div>
                                <div className='booking-activities-container'>
                                    {bookingActivity.packageActivities.map(act => <div className='booking-activity'>
                                        <img src={act.coverPhoto} height={64} width={64} />
                                        <span>{act.name}</span>
                                    </div>
                                    )}
                                </div>
                            </div>
                        </Col>
                    )}
                    {
                        payload?.description &&
                        getDescriptionOfPackageDiv()
                    }

                    {
                        (renderCancellation || renderReschedule) &&
                        getCancellationAndReschedulingRules()
                    }

                    {
                        payload?.termsAndConditions && Helper.stripHtmlTags(payload?.termsAndConditions) &&
                        getTermsAndConditionsLabel()
                    }

                    {
                        getMobileViewBottomStickyDiv()
                    }

                    <div className='bottom-filler'></div>

                    <TncModal
                        termsVisible={termsVisible}
                        termsAndConditions={payload?.termsAndConditions}
                        showHideTermsAndConditions={showHideTermsAndConditions}
                        buttonText={payload?.acknowledgementButtonText}
                        // acknowledgementFields={acknowledgementFields}
                        firebase={firebase}
                        // signatureRefs={signatureRefs}
                        // createBooking={createBooking}
                        isLoading={accountPackageReducer.isLoading}
                        viewMode={true}
                    />


                    {showBookingConfirmation &&
                        <BookingConfirmationPopup
                            showBookingConfirmation={showBookingConfirmation}
                            setShowBookingConfirmation={setShowBookingConfirmation}
                            bookingDetails={bookingDetails}
                            firebase={firebase}
                        />
                    }

                    {open ? (
                        payload?.bookingBasicDetails?.isDeferred ? (
                            <BookSlotsModal
                                open={openRescheduleModal}
                                setOpen={setOpenRescheduleModal}
                                totalClasses={payload?.bookingBasicDetails?.pricePackDuration || 0}
                                bookedClasses={payload?.bookedSlots?.slots || []}
                                remainingCredits={payload?.remainingCredits || 0}
                                packageId={payload?.id}
                                bookingPeriod={payload?.bookingBasicDetails?.startDate && payload?.bookingBasicDetails?.endDate ? {
                                    startDate: payload.bookingBasicDetails.startDate,
                                    endDate: payload.bookingBasicDetails.endDate
                                } : undefined}
                            />
                        ) : (
                            <RescheduleBookingModal
                                open={openRescheduleModal}
                                setOpen={setOpenRescheduleModal}
                                packageId={payload?.id}
                            />
                        )
                    ) : null}

                    {afterCancel &&
                        <div >
                            <div className='pbm-cpo-overlay'>
                                <div className='pbm-cpo-popup'>
                                    <p className='pbm-cpo-textAlignCenter fw-700' style={{ whiteSpace: "pre-wrap" }}>{formatMsg("afterCancel")}</p>
                                    <p className='pbm-cpo-textAlignLeft'>{formatMsg("desc.afterCancel")}</p>
                                    <div>{getButtonGroup()}</div>
                                </div>
                            </div>
                        </div>}

                    {beforeCancel &&
                        <div >
                            <div className='pbm-cpo-overlay'>
                                <div className='pbm-cpo-popup'>
                                    <p className='pbm-cpo-textAlignCenter fw-700' style={{ whiteSpace: "pre-wrap" }}>{formatMsg("beforeCancel")}</p>
                                    <div className='pbm-cpo-textAlignLeft mt-16'>
                                        {payload?.cancellationRules && <div className='popup-refund'>{formatMsg("popup.refundPolicy") + ": " + getRefundPolicy(payload.cancellationRules, payload.bookingBasicDetails.startDate)}</div>}
                                        {payload?.cancellationRules && <div>{formatMsg("cancellationNotice") + ": " + getCancellationNotice(payload?.cancellationRules)}</div>}
                                    </div>
                                    <div>{getButtonGroup()}</div>
                                </div>
                            </div>
                        </div>}


                    {rescheduleModal ? (
                        payload?.bookingBasicDetails?.isDeferred ? (
                            <BookSlotsModal
                                open={rescheduleModal}
                                setOpen={setRescheduleModal}
                                totalClasses={payload?.bookingBasicDetails?.pricePackDuration || 0}
                                bookedClasses={payload?.bookedSlots?.slots || []}
                                remainingCredits={payload.remainingCredits}
                                packageId={payload?.id}
                                bookingPeriod={payload?.bookingBasicDetails?.startDate && payload?.bookingBasicDetails?.endDate ? {
                                    startDate: payload.bookingBasicDetails.startDate,
                                    endDate: payload.bookingBasicDetails.endDate
                                } : undefined}
                            />
                        ) : (
                            <RescheduleBookingModal
                                open={rescheduleModal}
                                setOpen={setRescheduleModal}
                                remainingCredits={payload.remainingCredits}
                                packageId={payload?.id}
                            />
                        )
                    ) : null}
                </Row>

                <ModalWrapper
                    title={activeModal ? formatMsg(activeModal) : ''}
                    open={['pricing', 'centers', 'timings', 'dates'].includes(activeModal)}
                    onCancel={closeModal}
                    width={400}
                    footer={null}
                    className='batch-details-modal'
                >
                    {getModalData(activeModal, activeBatchIndex)}
                </ModalWrapper>
            </SpinWrapper>
        </Box>
    )
}

export default PackageBookingOrMembershipDetailView;


const styles: any = {
    wrap: {
        display: 'flex',
        flexWrap: 'wrap',
        marginBottom: 15
    },
    cardHeader: {
        fontSize: 16
    },
    closeButton: {
        position: 'fixed',
        top: '32px',
        right: '32px',
        background: 'rgba(0, 0, 0, 0.1)',
        color: '#fff',
        border: 'none',
        borderRadius: '50%',
        cursor: 'pointer',
        display: 'flex',
        transition: "0.3s"
    },
    downloadButton: {
        position: 'fixed',
        top: '32px',
        left: '32px',
        background: 'rgba(0, 0, 0, 0.1)',
        color: '#fff',
        border: 'none',
        borderRadius: '50%',
        cursor: 'pointer',
        display: 'flex',
        transition: "0.3s"
    },
    descriptionContainer: {
        marginTop: 28,
        marginBottom: 28,
        borderRadius: "8px 0px 0px 0px",
        background: "#FFFFFF",
        boxShadow: "0px 4px 25px 0px #0000000F",
        height: "auto",
        overflowY: "auto",
    },

    cancellationReschedulingPolicy: {
        borderRadius: "8px 0px 0px 0px",
        background: "#FFFFFF",
        boxShadow: "0px 4px 25px 0px #0000000F",
        height: "auto",
        overflowY: "auto",
    },
    downloadIcon: {
        display: "flex",
        justifyContent: "center",
        alignContent: "center",
        width: "45px",
        height: "45px"
    }
}